/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeactivateModelRegistryEntryRequest = {
  id: string;
};

/** @internal */
export const DeactivateModelRegistryEntryRequest$inboundSchema: z.ZodType<
  DeactivateModelRegistryEntryRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
});
/** @internal */
export type DeactivateModelRegistryEntryRequest$Outbound = {
  id: string;
};

/** @internal */
export const DeactivateModelRegistryEntryRequest$outboundSchema: z.ZodType<
  DeactivateModelRegistryEntryRequest$Outbound,
  z.ZodTypeDef,
  DeactivateModelRegistryEntryRequest
> = z.object({
  id: z.string(),
});

export function deactivateModelRegistryEntryRequestToJSON(
  deactivateModelRegistryEntryRequest: DeactivateModelRegistryEntryRequest,
): string {
  return JSON.stringify(
    DeactivateModelRegistryEntryRequest$outboundSchema.parse(
      deactivateModelRegistryEntryRequest,
    ),
  );
}
export function deactivateModelRegistryEntryRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeactivateModelRegistryEntryRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      DeactivateModelRegistryEntryRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeactivateModelRegistryEntryRequest' from JSON`,
  );
}
